/**
 * Extract the function output from contract ABI
 * USE WITH SMART CONTRACT FUNCTION WHICH RETURNS STRUCT OR TUPLE OBJECT
 * example return
 * [
 {
    "components": [
      {
        "name": "name",
        "type": "string"
      },
      {
        "name": "price",
        "type": "uint256"
      },
      {
        "name": "quantity",
        "type": "uint256"
      }
    ],
    "name": "",
    "type": "tuple"
  },
 {
    "components": [
      {
        "name": "properties",
        "type": "string"
      },
    ],
    "name": "",
    "type": "tuple"
  }
 ]
 * @param functionName
 * @param contractAbi
 * @return [Array]
 */
export async function getFunctionOutputAbi(functionName, contractAbi) {
  // only use with smart contract function which returns STRUCT OR TUPLE object
  return contractAbi
    .map(eachObject => {
      if (eachObject['name'] && eachObject['name'] === functionName && eachObject['type'] === 'function') {
        return eachObject.outputs;
      }
      return null;
    })
    .filter(notNull => {
      // eslint-disable-next-line
      return notNull != null;
    })
    .reduce((returnArray, childArray) => {
      // flatten array
      return returnArray.concat(childArray);
    }, []);
}

/**
 * Extract the function output from contract ABI
 * example return
 * [
 {
    "anonymous": false,
    "inputs": [
      {
        "indexed": false,
        "name": "cryptoAddress",
        "type": "address"
      },
      {
        "indexed": false,
        "name": "createdAt",
        "type": "uint256"
      }
    ],
    "name": "LogRegisterShop",
    "type": "event"
}
 ]
 * @param eventName
 * @param contractAbi
 * @return [Array]
 */
export async function getEventOutputAbi(eventName, contractAbi) {
  return contractAbi
    .map(eachObject => {
      if (
        eachObject['name'] &&
        eachObject['name'] === eventName &&
        eachObject['type'] &&
        eachObject['type'] === 'event'
      ) {
        return eachObject.inputs;
      }
      return null;
    })
    .filter(notNull => {
      // eslint-disable-next-line
      return notNull != null;
    })
    .reduce((returnArray, childArray) => {
      // flatten array
      return returnArray.concat(childArray);
    }, []);
}

/**
 * Parsing param name and type, based on that defined the return value in array
 * @param param, something like:
 * {
 *   "name": "properties",
 *   "type": "string"
 * }
 * @param array
 * @returns object: {
 *  key: paramName,
 *  value: array[paramName]
 *  }
 */
export function paramParser(param, array) {
  const paramName = param.name;
  if (array && array[paramName] !== undefined) {
    const paramValue = param.type.indexOf('uint') >= 0 ? parseInt(array[paramName]) : array[paramName];
    return {
      key: paramName,
      value: paramValue
    };
  } else {
    return {
      key: paramName,
      value: null
    };
  }
}
